"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var formatDateInLocalTimezone = function formatDateInLocalTimezone(timestamp, locale) {
  var communityLanguage = typeof window !== 'undefined' ? (0, _globals.default)('communityLanguage') || 'en-US' : 'en-US';
  return new Intl.DateTimeFormat(locale !== null && locale !== void 0 ? locale : communityLanguage, {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }).format(timestamp);
};

var _default = formatDateInLocalTimezone;
exports.default = _default;